module.exports = __webpack_public_path__ + "img/tablero-sin-pantalla.f185755a.svg";